"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HangulImeInputWrapper = void 0;
var hangul_ime_1 = __importStar(require("hangul-ime"));
var grapheme_splitter_1 = __importDefault(require("grapheme-splitter"));
var splitter = new grapheme_splitter_1.default();
var HangulImeInputWrapper = /** @class */ (function () {
    function HangulImeInputWrapper(inputElement) {
        var _this = this;
        this._latestCursor = 0;
        this._imeMode = "none";
        this._ime = new hangul_ime_1.default();
        this.insertOtherCharacter = function (key) {
            var inputEle = _this._inputElement;
            var inputCursor = inputEle.selectionStart;
            var originText = inputEle.value;
            var frontText = "" + originText.slice(0, inputCursor) + key;
            var backText = "" + originText.slice(inputCursor);
            var fullText = "" + frontText + backText;
            var cursor = frontText.length;
            inputEle.value = fullText;
            _this.moveCursor(cursor);
            _this._imeMode = "none";
            _this._ime.clear();
        };
        this.backspaceOnInputElement = function () {
            var inputEle = _this._inputElement;
            var inputCursor = inputEle.selectionStart;
            if (inputCursor <= 0)
                return;
            var originText = inputEle.value;
            var frontText = "" + originText.slice(0, inputCursor);
            var backText = "" + originText.slice(inputCursor);
            var modifiedFontText = _this.deleteLastCharacter(frontText);
            inputEle.value = "" + modifiedFontText + backText;
            var cusorPosition = modifiedFontText.split("").length;
            _this.moveCursor(cusorPosition);
            _this._imeMode = "none";
            _this._ime.clear();
        };
        this.compose = function (composingChar) {
            var inputEle = _this._inputElement;
            var inputCursor = inputEle.selectionStart;
            var text = inputEle.value.split("");
            if (text.length <= 0) {
                text.push(composingChar);
                _this.changeText(text);
                _this.moveCursor(inputCursor + 1);
            }
            else if (_this._imeMode === "none") {
                text.splice(inputCursor, 0, composingChar);
                _this.changeText(text);
                _this.moveCursor(inputCursor + 1);
            }
            else {
                text[inputCursor - 1] = composingChar;
                _this.changeText(text);
                _this.moveCursor(inputCursor);
            }
            _this._imeMode = "composing";
        };
        this.complete = function (completedChar, composingChar) {
            var inputEle = _this._inputElement;
            var text = inputEle.value.split("");
            var oldCharCursor = inputEle.selectionStart - 1;
            text[oldCharCursor] = completedChar;
            var newCharCursor = inputEle.selectionStart;
            text.splice(newCharCursor, 0, composingChar);
            _this.changeText(text);
            _this.moveCursor(newCharCursor + 1);
            _this._imeMode = "composing";
        };
        this.moveCursor = function (cursor) {
            _this._inputElement.setSelectionRange(cursor, cursor);
            _this._inputElement.focus();
            _this._latestCursor = cursor;
        };
        this.changeText = function (chars) {
            _this._inputElement.value = chars.reduce(function (prev, cnt) { return "" + prev + cnt; });
        };
        this._inputElement = inputElement;
    }
    /**
     * 글자를 추가합니다
     * @param character 입력할 글자
     * @example 글자를 입력한다
     * ```
     * ime.insert("ㄱ");
     * ime.insert("a");
     * ime.insert(" ");
     * ime.insert("😍");
     * ```
     */
    HangulImeInputWrapper.prototype.insert = function (character) {
        if (hangul_ime_1.isJamo(character)) {
            this._ime
                .insert(character)
                .onComplete(this.complete)
                .onCompose(this.compose);
        }
        else {
            this._ime.clear();
            this.insertOtherCharacter(character);
        }
    };
    /**
     * 백스페이스
     */
    HangulImeInputWrapper.prototype.backspace = function () {
        this._ime
            .backspace()
            .onEmpty(this.backspaceOnInputElement)
            .onCompose(this.compose);
    };
    /**
     * input에서 변경된 select를 확인한다
     */
    HangulImeInputWrapper.prototype.checkChangedSelect = function () {
        if (this._latestCursor !== this._inputElement.selectionStart) {
            this._imeMode = "none";
            this._ime.clear();
        }
    };
    HangulImeInputWrapper.prototype.deleteLastCharacter = function (text) {
        var chars = splitter.splitGraphemes(text);
        chars.splice(chars.length - 1, 1);
        var modifiedText = chars.length > 0
            ? chars.reduce(function (preValue, cntValue) {
                return preValue + cntValue;
            })
            : "";
        return modifiedText;
    };
    return HangulImeInputWrapper;
}());
exports.HangulImeInputWrapper = HangulImeInputWrapper;
